/* eslint-disable no-param-reassign */
/* eslint-disable no-case-declarations */
import { MomentInput } from 'moment';
import * as constants from 'common/constants/financials';
import { TableData } from 'common/types/scalarSpreadsheet';
import { GridDateEditor, GridDateValueViewer } from 'components/FeaturedSpreadsheet/components';
import { EqualSymbol, NotEqualSymbol } from 'icons';
import { IScalarSpreadsheetConfig } from 'models/interfaces/spreadsheet-types/core-types';
import reverseParser from 'pages/Financials/balance-sheet/utilities/reverseParser';
import { FinancialsDate } from 'pages/Financials/components';
import { columnUpdateActionCallback } from 'pages/Financials/utilities';
import { gridShortDate, isValidDate } from 'utilities';
import { AddActionArgs, BalanceSheetCell } from '../types';

const conditions = ({
  cell,
  cells: scope,
  onCellsChanged,
  tableData,
}: {
  cell: BalanceSheetCell;
  cells: IScalarSpreadsheetConfig;
  onCellsChanged: (cells: IScalarSpreadsheetConfig) => void;
  tableData: TableData<BalanceSheetCell>;
}) => {
  const { alias, isLTM } = cell;
  const { isDisabled } = tableData;

  const addAction = ({ title, isEqual, callback, buttonText, position = 'right' }: AddActionArgs) => {
    cell.action = {
      position,
      icon: isEqual ? <EqualSymbol /> : <NotEqualSymbol />,
      tooltip: {
        visible: !isEqual,
        title,
        buttonText,
      },
      callback,
    };
  };

  const enableUpdateColumn = (args: AddActionArgs = {} as AddActionArgs) => {
    if (cell.needs_actualization) {
      addAction({
        ...args,
        title: constants.COLUMN_UPDATED_ACTION_TITLE,
        isEqual: true,
        callback: () =>
          columnUpdateActionCallback({
            cell,
            onCellsChanged: onCellsChanged as any,
            scope: scope as any,
            reverseParser: reverseParser as any,
          }),
        buttonText: constants.COLUMN_UPDATED,
      });
    }
  };

  const enableEditableDate = () => {
    if (isValidDate(cell.value as MomentInput)) {
      cell.readOnly = isDisabled;
      cell.value = gridShortDate(cell.value as MomentInput);
      cell.className = 'date-editor-white';

      // any due to legacy component typing
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      cell.gridDateComponent = FinancialsDate as any;
      cell.dataEditor = props => <GridDateEditor {...props} />;
      cell.valueViewer = (props: any) => <GridDateValueViewer {...props} />;
    }
  };

  switch (alias) {
    case constants.FIRST_ROW_ALIAS:
      if (cell.rowSpan === 3) {
        enableUpdateColumn({ position: 'center' } as AddActionArgs);
      }
      break;
    case constants.SECOND_ROW_ALIAS:
      if (isLTM) {
        enableEditableDate();
      } else {
        enableUpdateColumn();
      }
      break;
    default:
      break;
  }

  return cell;
};

export default conditions;
